import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

/**
 * The purpose of this class is to handle error in production or test env.
 * This can be useful for caching or logging error using external services.
 * Further doc can be found in :
 * https://netbasal.com/angular-2-custom-exception-handler-1bcbc45c3230
 */
export class CustomErrorHandler extends ErrorHandler {

  constructor() {
    // The true paramter tells Angular to rethrow exceptions, so operations like 'bootstrap' will result in an error
    // when an error happens. If we do not rethrow, bootstrap will always succeed.
    super();
  }

  /**
   *
   * @param error
   */
  handleError(error) {
    // send the error to the server
    // Todo: Call logging service (e/g Loggly)

    // In dev env environment we want to see the default behaviour of angular error handler
    // Angular idefault mplementation of ErrorHandler prints errors messages to the console
    // delegate to the default handler
    super.handleError(error);
  }
}
